import { collapsibleValueGroup } from '~/components/AiSearchChips/OrValueGroupChip/orValueGroupCollapse';
import { nextPredicate } from '~/components/AiSearchChips/StringMatchChip/StringMatchChip.utils';
const AGREEMENT_OR_VALUE_GROUP_EDITORS = {
    agreementTitle: 'text',
    clientName: 'text',
    contactName: 'text',
    assigneeName: 'text',
    effectiveDate: 'date',
    approvalDate: 'date'
};
export const collapsibleAgreementGroup = (arms)=>collapsibleValueGroup(AGREEMENT_OR_VALUE_GROUP_EDITORS, arms);
export const agreementOrValueGroupFields = (texts)=>({
        agreementTitle: {
            editor: AGREEMENT_OR_VALUE_GROUP_EDITORS.agreementTitle,
            label: texts.labels.agreementTitle
        },
        clientName: {
            editor: AGREEMENT_OR_VALUE_GROUP_EDITORS.clientName,
            label: texts.labels.clientName
        },
        contactName: {
            editor: AGREEMENT_OR_VALUE_GROUP_EDITORS.contactName,
            label: texts.labels.contactName
        },
        assigneeName: {
            editor: AGREEMENT_OR_VALUE_GROUP_EDITORS.assigneeName,
            label: texts.labels.assignee
        },
        effectiveDate: {
            editor: AGREEMENT_OR_VALUE_GROUP_EDITORS.effectiveDate,
            label: texts.labels.effectiveDate
        },
        approvalDate: {
            editor: AGREEMENT_OR_VALUE_GROUP_EDITORS.approvalDate,
            label: texts.labels.approvalDate
        }
    });
export const agreementCollapsedGroupArm = (group, index, value)=>{
    if (value == null) return undefined;
    return group.kind === 'string' ? {
        [group.field]: nextPredicate(value, group.predicates[index])
    } : {
        [group.field]: {
            eq: value
        }
    };
};
